export default __webpack_public_path__ + "static/media/boston.6e15339a.jpeg";